export default __webpack_public_path__ + "69961d3ad6fe1a8f59cf06ecd4909c6b.jpg";